/**
 * signalPriorityResolver — Collapses all active intelligence signals to 3-5 most relevant.
 *
 * Priority tiers:
 *   Tier 1 — Critical: crisis, exhaustion, grief (max 1 preempts lower tiers)
 *   Tier 2 — Important: complexity, silence, isolation, rhythm loss, regression
 *   Tier 3 — Contextual: conflict, load, boundary, escalation, pacing
 *
 * At most MAX_SIGNALS total. Excess signals are suppressed.
 */

const MAX_SIGNALS = 5;

const PRIORITY_TIERS = [
  { key: "crisis",      test: ({ riskLevel }) => riskLevel === "critical" || riskLevel === "high" },
  { key: "exhaustion",  test: ({ exhaustionState }) => exhaustionState === "saturación_crítica" || exhaustionState === "desgaste_profundo" },
  { key: "grief",       test: ({ emotion }) => emotion?.dominant === "duelo" || emotion?.dominant === "pérdida" || emotion?.dominant === "dolor_profundo" },
  { key: "complexity",  test: ({ complexity }) => complexity === "deeply_complex" || complexity === "delicate" },
  { key: "silence",     test: ({ silentTension }) => (silentTension ?? 0) >= 2 },
  { key: "isolation",   test: ({ isolationState }) => isolationState === "aislamiento_profundo" || isolationState === "aislamiento_pastoral" },
  { key: "rhythm_loss", test: ({ rhythmState }) => rhythmState === "ritmo_colapsado" || rhythmState === "ritmo_fragmentado" },
  { key: "regression",  test: ({ regressionState }) => regressionState === "sustained_regression" || regressionState === "regression" },
  { key: "conflict",    test: ({ conflictType }) => conflictType && conflictType !== "ninguno" },
  { key: "load",        test: ({ loadState }) => loadState === "high" },
  { key: "boundary",    test: ({ boundaryState }) => boundaryState && boundaryState !== "saludable" },
  { key: "escalation",  test: ({ escalation }) => escalation && escalation !== "maintain" },
  { key: "pacing",      test: ({ pace }) => pace === "pause_and_hold" || pace === "slow_down" },
];

export function resolveSignalPriority({ riskLevel, emotion, complexity, silentTension, exhaustionState, isolationState, rhythmState, regressionState, conflictType, loadState, boundaryState, escalation, pace }) {
  const activeSignals = [];
  const suppressed    = [];

  for (const tier of PRIORITY_TIERS) {
    if (tier.test({ riskLevel, emotion, complexity, silentTension, exhaustionState, isolationState, rhythmState, regressionState, conflictType, loadState, boundaryState, escalation, pace })) {
      if (activeSignals.length < MAX_SIGNALS) {
        activeSignals.push(tier.key);
      } else {
        suppressed.push(tier.key);
      }
    }
  }

  return { activeSignals, suppressed, signalCount: activeSignals.length };
}
